<template>
  <div class="box box-primary">
    <div class="box-header">
      <h3 class="box-title">Assign New Service To Customer</h3>
    </div>
    <div class="box-body">
      <b-form @submit="onSubmit" @reset="onReset" v-if="show">

        <b-form-group label="Services Available:" label-for="services">
          <b-form-select 
            :options="services" 
            required 
            v-model="form.service" 
            class="form-control"
            @change="onChange" 
          />
        </b-form-group>

        <b-form-group label="Devices:" label-for="devices">
          <b-form-select 
          :options="devices" 
          required 
          v-model="form.device"
          @change="onDeviceChange"
          class="form-control" />
        </b-form-group>

        <!-- Date From -->
        <div class="form-group">
          <label>Date From:</label>

          <div class="input-group date">
            <div class="input-group-addon">
              <i class="fa fa-calendar"></i>
            </div>
            <date-picker v-model="form.dateFrom" :config="options"></date-picker>
          </div>
          <!-- /.input group -->
        </div>
        <!-- /.form group -->

        <!-- Date From -->
        <div class="form-group">
          <label>Date To:</label>

          <div class="input-group date">
            <div class="input-group-addon">
              <i class="fa fa-calendar"></i>
            </div>
            <date-picker v-model="form.dateTo" :config="options"></date-picker>
          </div>
          <!-- /.input group -->
        </div>
        <!-- /.form group -->

        <b-button type="submit" variant="primary">Submit</b-button>
        <b-button type="reset" variant="danger">Reset</b-button>
        <button type="button" class="btn btn-success pull-right" style="margin-right: 5px;"
          @click="onClickCancel" >{{$t('common.cancel')}}</button>
      </b-form>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import LTECoreAlert from "@/components/LTESnackBar.vue"
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import Moment from "moment"
// import utils from '@/lib/utils'
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);


export default {
  name: 'AssignService',
  data() {
    return {
      form: {
        dateFrom: new Date(),
        dateTo: null,
        service: null,
        device: null,
        user:this.$route.params.id
      },
      services: [{ text: 'Select One', value: null, type: null}],
      devices: [{ text: 'Select One', value: null }],
      show: true,
      options: {
        // format: 'DD/MM/YYYY',
        format: '',
        useCurrent: false
      },
      items: [],
      disableDateRange: []
    }
  },
  watch: {
    SERVICE_ASSIGNED_DATA: function() {
      // this.items = []
      this.SERVICE_ASSIGNED_DATA.forEach(
        service_data => {
          let dateRange = null
          let service_name      = service_data.service_name.split('-')[0]
          let property_name     = service_data.service_name.split('-')[1]
          let date_from         = new Date(service_data.date_from)
          let date_to           = new Date(service_data.date_to)
          let id                = service_data.id
          let tmp = []
          dateRange = moment().range(date_from, date_to)
          let array = Array.from(dateRange.by("days"));
          array.map(date => {
              tmp.push(date.format('MM-DD-YYYY'))
          });
          let data              = {
              'id': id,
              'service_name'  : service_name.trim(),
              'property_name' : property_name.trim(),
              'dateRange' : tmp
          };
        this.items.push(data)
        }
      );
      return this.items
    }
  },
  computed: {
    ...mapGetters([
    "GET_ACCOUNT_DATA",
    "SERVICE_ASSIGNED_DATA"
  ]),
  },
  methods: {
    ...mapActions([
      "GET_SERVICE_LIST_NO_PAGE",
      "GET_PROPERTY_LIST_NO_PAGE",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_SERVICE_LIST_BY_USER"
      ]),

    disableDates: function() {
      let dates = []
      this.items.forEach(item => {
        let serviceText = ''
        this.services.forEach(service => {
          if(service.value == this.form.service){
            serviceText = service.text
          }
        });
        let deviceText = ''
        this.devices.forEach(device => {
          if(device.value == this.form.device){
            deviceText = device.text
          }
        })

        if(item.property_name == deviceText && item.service_name == serviceText){
          dates = dates.concat(item.dateRange)
        }
      });
      return dates
    },
    onDeviceChange: function(){
      if(this.disableDates().length > 0){
        this.disableDateRange = this.disableDates()
          this.options = {
            disabledDates: this.disableDateRange
          }
      } else {
        this.options = {
        disabledDates: []
      }
      }
    },
    onChange(val) {
      this.options = {
        disabledDates: []
      }
      this.devices = [{ text: 'Select One', value: null }]
      this.form.device = null
      let data
      this.services.forEach(v => {
        if (v.value === val) {
          data = v
          return true
        }
      })
      if (data.type !== null){
        this.GET_PROPERTY_LIST_NO_PAGE({propertytype: data.type}).then(
          function(res) {
            let result = res.data
            result.forEach(v => {
              let data = {
                text: v.name,
                value: v.id
              }
              this.devices.push(data)
            })
          }.bind(this)
        )
      }
    },
    onSubmit(evt) {
      evt.preventDefault()
      let tmp = []
      let hasDisable = false
      let dateRange = moment().range(this.form.dateFrom, this.form.dateTo)
      let array = Array.from(dateRange.by("days"));
      array.map(date => {
          tmp.push(date.format('MM-DD-YYYY'))
      });

      this.disableDateRange.some(disableDate => {
          tmp.some(selectedDate => {
            if(disableDate == selectedDate){
              hasDisable = true
              return true
            }
          })
          if(hasDisable){
            return true
          }
      })
      
      if(hasDisable) {
        alert('Cannot select exiting service dates!')
      }
      else {
        let payload = {}
        payload = {
          "propertyinservices": [
            {
              "prop"  :this.form.device
            }
          ],
          "assignedservicehistory": [
            {
              "user_created": this.GET_ACCOUNT_DATA.id
            }
          ],
          "date_from" : this.form.dateFrom,
          "date_to"   : this.form.dateTo,
          "service"   : this.form.service,
          "user"      : this.form.user
        },

        this.$emit("assignservice-submit", payload)
      }
      
    },
    onClickCancel: function(){
      this.$emit("assignservice-cancel", {})
    },
    onReset(evt) {
      evt.preventDefault()
      /* Reset our form values */
     
      this.form.service = null
      this.form.device = null
      this.form.dateTo = null
      /* Trick to reset/clear native browser form validation state */
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  },
  components: {
    'date-picker': datePicker
  },
  mounted() {
    this.user = this.$route.params.id;
    this.GET_SERVICE_LIST_NO_PAGE().then(
      function(res) {
        let result = res.data
        result.forEach(v => {
          let data = {
            text: v.name,
            value: v.id,
            type: v.service_type
          }
          this.services.push(data)
        })
      }.bind(this)
    )
    let data = {
      userid: this.user
    }
    this.GET_SERVICE_LIST_BY_USER(data)
  }
}

</script>



// WEBPACK FOOTER //
// src/views/Service/AssignService.vue